module.exports = __webpack_public_path__ + "media/scene_6.200bd20a.mp3";